/**
 * "R$ 1.234,56" / "2.500" / "1234.5" / "45" → número; null se não for número.
 * Espelho de parseNumberBR (src/services/intelligence.ts) — é o que o servidor grava.
 */
export function parseNumberBR(raw: string): number | null {
  const s = raw.replace(/[^\d,.-]/g, '')
  if (!s) return null
  const normalized = s.includes(',')
    ? s.replace(/\./g, '').replace(',', '.')
    : /^-?\d{1,3}(\.\d{3})+$/.test(s)
      ? s.replace(/\./g, '')
      : s
  const n = Number(normalized)
  return Number.isFinite(n) ? n : null
}

export const fmtNumberBR = (n: number) => n.toLocaleString('pt-BR', { maximumFractionDigits: 2 })

/** Sempre com 2 casas ("2.500,00", "9,00"): deixa claro o que é milhar e o que é decimal. */
export const fmtExactBR = (n: number) =>
  n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

/** ROAS é em vezes (9 = R$ 9 por R$ 1): 50 ou mais quase sempre é porcentagem digitada. */
export function roasPercentHint(metric: string | null | undefined, n: number | null): string | null {
  if (metric !== 'roas' || n == null || n < 50) return null
  return (
    `ROAS é em vezes (9 = R$ 9 de receita por R$ 1 investido). ${fmtNumberBR(n)} parece porcentagem — ` +
    `${fmtNumberBR(n)}% = ${fmtNumberBR(n / 100)}.`
  )
}
